import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import Stat from "./Stat";
import ActionAreas from "./ActionAreas";
import { GraphicsContext } from "../../contexts/GraphicsContext";
import { DataContext } from "../../contexts/DataContext";
import { APIContext } from "../../contexts/APIContext";
import { UIContext } from "../../contexts/UIContext";
import { ClockContext } from "../../contexts/ClockContext";
import { ScrollBar } from "../../Theme/Hyper";
import Select from "react-select";
const Main = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const Scroll = styled(ScrollBar)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: ${(props) => (props.short ? "400px" : "600px")};
`;
const Row = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  font-size: 1em;
  font-weight: 100;
  align-items: center;
`;
const Button = styled.div`
  padding: 0.5em;
  min-width: 50px;
  display: flex;
  background-color: ${(props) =>
    props.selected ? "#db0a41" : props.green ? "#0adb93" : "#202731"};
  color: ${(props) => (props.green ? "#000" : "#fff")};
  justify-content: center;
  align-items: center;
  height: 55%;
  border-radius: 4px;
  margin: 0.5em;
  box-sizing: border-box;
  :hover {
    background-color: ${(props) => (props.green ? "#0adb93" : "#db0a41")};
    cursor: pointer;
  }
`;
const CBButton = styled(Button)`
  height: 10px;
  margin: 2px;
  background-color: ${(props) => (props.selected ? "#0adb93" : "")};
  color: ${(props) => (props.selected ? "#1d1d1d" : "")};
  margin-right: auto;
`;
const SelectContainer = styled(Select)`
  min-width: 200px;
  margin-bottom: 0.5em;
  width: 100%;
`;
const names = [
  {
    id: "attacking_kicks",
    name: "Attacking Kicks",
  },
  {
    id: "av_gain",
    name: "Average Gain",
  },
  {
    id: "carries",
    name: "Carries",
  },
  {
    id: "clean_break",
    name: "Linebreaks",
  },
  {
    id: "drop_goals",
    name: "Drop Goals",
  },
  {
    id: "errors",
    name: "Errors",
  },
  {
    id: "forty_twenty",
    name: "40/20s",
  },
  {
    id: "game_id",
    name: "",
  },
  {
    id: "goals",
    name: "",
  },
  {
    id: "kicks_in_gen_play",
    name: "Kicks in General Play",
  },
  {
    id: "marker_tackles",
    name: "Marker Tackles",
  },
  {
    id: "metres",
    name: "Metres",
  },
  {
    id: "missed_goals",
    name: "",
  },
  {
    id: "missed_tackles",
    name: "Missed Tackles",
  },
  {
    id: "offload",
    name: "Offloads",
  },
  {
    id: "penalties",
    name: "Penalties Conceded",
  },
  {
    id: "player_id",
    name: "",
  },
  {
    id: "red_card",
    name: "",
  },
  {
    id: "run_from_dummy_half",
    name: "Runs from Dummy Half",
  },
  {
    id: "tackle_busts",
    name: "Tackle Busts",
  },
  {
    id: "tackles",
    name: "Tackles",
  },
  {
    id: "team_id",
    name: "",
  },
  {
    id: "tries",
    name: "Tries",
  },
  {
    id: "try_assists",
    name: "Try Assists",
  },
  {
    id: "yellow_card",
    name: "",
  },
  {
    id: "break_assist",
    name: "Linebreak Assists",
  },
  {
    id: "conversions",
    name: "Conversions",
  },
  {
    id: "dummy_half_metres",
    name: "Dummy Half Metres",
  },
  {
    id: "hit_up_metres",
    name: "Hit Up Metres",
  },
  {
    id: "hit_ups",
    name: "Hit Ups",
  },
  {
    id: "kick_from_hand_metres",
    name: "Kick from Hand Metres",
  },
  {
    id: "kick_return_metres",
    name: "Kick Return Metres",
  },
  {
    id: "kick_returns",
    name: "Kick Returns",
  },
  {
    id: "minutes_player_total",
    name: "Minutes",
  },
  {
    id: "missed_conversions",
    name: "",
  },
  {
    id: "missed_penalty_goals",
    name: "",
  },
  {
    id: "on_report",
    name: "",
  },
  {
    id: "passes",
    name: "Passes",
  },
  {
    id: "penalty_goals",
    name: "",
  },
  {
    id: "twenty_forty",
    name: "20/40s",
  },
  {
    id: "ruck_infringements",
    name: "Ruck Infringements",
  },
  {
    id: "set_restart_conceded_10m_offside",
    name: "Six Agains Conceded (10m Offside)",
  },
  {
    id: "set_restart_won",
    name: "Six Agains Won",
  },
  {
    id: "kick_defused",
    name: "Kicks Defused",
  },
  {
    id: "kick_not_defused",
    name: "Kicks Not Defused",
  },
  {
    id: "ball_run_metres",
    name: "Carry Metres",
  },
  {
    id: "post_contact_metres",
    name: "Post Contact Metres",
  },
  {
    id: "one_on_one_steal",
    name: "One-on-One Steal",
  },
  {
    id: "one_point_field_goal",
    name: "",
  },
  {
    id: "two_point_field_goal",
    name: "",
  },
  {
    id: "tackle_efficiency",
    name: "Tackle Success",
    percent: true,
  },
  {
    id: "goal_line_dropout",
    name: "Goal Line Dropouts",
  },
  {
    id: "possession",
    name: "Possession",
  },
  {
    id: "missed_field_goals",
    name: "",
  },
  {
    id: "ptb_opp_20m",
    name: "PTBs in Opp. 20",
  },
  {
    id: "set_handover",
    name: "Set handovers",
  },
  {
    id: "kick_receipt",
    name: "Kick Receipts",
  },
  {
    id: "minutes_played_total",
    name: "Minutes Played",
  },
  {
    id: "top_scorers",
    name: "Point Scorers",
  },
  {
    id: "scrum_won",
    name: "Scrums Won",
  },
  {
    id: "scrum_lost",
    name: "Scrums Lost",
  },
  {
    id: "on_report",
    name: "",
  },
  {
    id: "complete_sets",
    name: "Sets Completed",
  },
  {
    id: "completionPercentage",
    name: "Completion Rate",
    percent: true,
  },
  {
    id: "incomplete_sets",
    name: "Incomplete Sets",
  },
  {
    id: "play_the_ball",
    name: "PTBs",
  },

];

const DropdownStyles = {
  menu: (provided) => ({
    ...provided,
    backgroundColor: "#0e1219",
  }),
  option: (provided, state) => {
    return {
      ...provided,
      backgroundColor: "#0e1219",
      "&:hover": {
        color: "#db0a41",
      },
    };
  },
  control: (provided) => ({
    ...provided,
    backgroundColor: "#0e1219",
    borderColor: "#384454",
  }),
  valueContainer: (provided) => ({
    ...provided,
    backgroundColor: "#0e1219",
    borderColor: "#384454",
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = "opacity 300ms";

    return { ...provided, opacity, transition, color: "#fff" };
  },
};
export default function OPTATeamStats({ game }) {
  const { previewGraphic, animateOffGraphic, graphicInPreview } =
    useContext(GraphicsContext);
  const {
    setLastRowStatSelected,
    lastRowStatSelected,
    matchStatCollection,
    setMatchStatCollection,
  } = useContext(UIContext);
  const [selectedStat, setSelectedStat] = useState();

  return (
    <Main>
      OPTA
      <Scroll
        short={
          window.ENV?.REACT_APP_CATALANS === "true" ||
          process.env.REACT_APP_CATALANS === "true"
        }
      >
        <Row>
          <div style={{ width: "90%", marginTop: "15px" }}>
            Last row stat for FF Match Stats
            <SelectContainer
              styles={DropdownStyles}
              setSize={true}
              value={{
                value: lastRowStatSelected,
                label: names?.find((e) => e.id === lastRowStatSelected?.id)
                  ?.name,
              }}
              options={names
                ?.filter((n) => n?.name !== "")
                ?.sort((a, b) => {
                  if (a.name < b.name) {
                    return -1;
                  }
                  if (a.name > b.name) {
                    return 1;
                  }
                  return 0;
                })
                ?.map((item, index) => {
                  return {
                    value: item,
                    label: item.name,
                  };
                })}
              onChange={(e) => {
                setLastRowStatSelected(e.value);
              }}
              placeholder="Stat"
            />
          </div>
        </Row>
        <Row>
          <CBButton
            onClick={() => {
              setMatchStatCollection([]);
            }}
          >
            Clr
          </CBButton>
        </Row>
        <Row>
          <Stat
            stat_key={"Pre-match win predictor"}
            game={game}
            category={"Pre-match win predictor"}
            title={""}
            matchStats={[]}
            previewGraphic={(name, options) => {
              previewGraphic("WinPredictor", {
                ...options,
                game,
                title: "Win Predictor",
              });
            }}
            animateOffGraphic={animateOffGraphic}
            graphicInPreview={graphicInPreview}
            stat={{
              home:
                (Math.floor(
                  parseFloat(
                    game?.win_predictor?.prematchProbabilities?.home_win,
                  ) * 100,
                ) || 0) + "%",
              away:
                (Math.floor(
                  parseFloat(
                    game?.win_predictor?.prematchProbabilities?.away_win,
                  ) * 100,
                ) || 0) + "%",
            }}
            selectedtStat={selectedStat}
            setSelectedStat={setSelectedStat}
            line_2={""}
            showCB={true}
            matchStatCollection={matchStatCollection}
            setMatchStatCollection={setMatchStatCollection}
          />
        </Row>
        <Row>
          <Stat
            stat_key={"Live win predictor"}
            game={game}
            category={"Live win predictor"}
            title={""}
            matchStats={[]}
            previewGraphic={(name, options) => {
              previewGraphic("WinPredictor", {
                ...options,
                game,
                title: "Live Win Predictor",
              });
            }}
            animateOffGraphic={animateOffGraphic}
            graphicInPreview={graphicInPreview}
            stat={{
              home:
                (Math.floor(
                  parseFloat(
                    game?.win_predictor?.currentProbabilities?.home_win,
                  ) * 100,
                ) || 0) + "%",
              away:
                (Math.floor(
                  parseFloat(
                    game?.win_predictor?.currentProbabilities?.away_win,
                  ) * 100,
                ) || 0) + "%",
            }}
            selectedtStat={selectedStat}
            setSelectedStat={setSelectedStat}
            line_2={""}
            showCB={true}
            matchStatCollection={matchStatCollection}
            setMatchStatCollection={setMatchStatCollection}
          />
        </Row>
        {Object.keys({
          ...(game.opta_home_team_stats || {}),
          ...(game.opta_away_team_stats || {}),
        })
          ?.filter(
            (key) =>
              names?.find((s) => s.id === key) &&
              names?.find((s) => s.id === key)?.name !== "",
          )
          ?.sort((a, b) => {
            let a_name = names?.find((s) => s.id === a)?.name;
            let b_name = names?.find((s) => s.id === b)?.name;
            if (a_name === "Sets completed") {
              a_name = "Completion Rate";
            }
            if (b_name === "Sets completed") {
              b_name = "Completion Rate";
            }

            if (a_name < b_name) {
              return -1;
            }
            if (a_name > b_name) {
              return 1;
            }
            return 0;
          })
          ?.map((key) => {
            let home_stat = game?.opta_home_team_stats?.[key] || 0;
            let away_stat = game?.opta_away_team_stats?.[key] || 0;
            if (key === "completionPercentage") {
              home_stat = Math.round(home_stat);
              away_stat = Math.round(away_stat);
            }
            if (key === "tackle_efficiency") {
              home_stat = Math.round(home_stat);
              away_stat = Math.round(away_stat);
            }
            if (key === "complete_sets") {
              home_stat =
                home_stat +
                "/" +
                (parseInt(home_stat) +
                  parseInt(
                    game?.opta_home_team_stats?.["incomplete_sets"] || 0,
                  ));
              away_stat =
                away_stat +
                "/" +
                (parseInt(away_stat) +
                  parseInt(
                    game?.opta_away_team_stats?.["incomplete_sets"] || 0,
                  ));
            }

            return (
              <Row>
                <Stat
                  key={key}
                  game={game}
                  stat_key={key}
                  category={names?.find((s) => s.id === key)?.name || key}
                  matchStats={[]}
                  previewGraphic={previewGraphic}
                  animateOffGraphic={animateOffGraphic}
                  graphicInPreview={graphicInPreview}
                  stat={{
                    home:
                      home_stat +
                      (names?.find((s) => s.id === key)?.percent ? "%" : ""),
                    away:
                      away_stat +
                      (names?.find((s) => s.id === key)?.percent ? "%" : ""),
                  }}
                  selectedtStat={selectedStat}
                  setSelectedStat={setSelectedStat}
                  line_2={names?.find((s) => s.id === key)?.line_2 || ""}
                  showCB={true}
                  matchStatCollection={matchStatCollection}
                  setMatchStatCollection={setMatchStatCollection}
                />
              </Row>
            );
          })}
      </Scroll>
    </Main>
  );
}
